export const filterDecimal = (value) => {
  if (Math.round(value) !== value) {
    return value.toFixed(2);
  }

  return value;
};
